import React, { useState } from 'react'
import '../assets/style.css'
import logo from '../assets/images/logo.png'
import {Link,useNavigate } from 'react-router-dom'
import UseSearch from '../hooks/useSearch'

function Navbar() {
  const navigate = useNavigate()
  const {data,getData} = UseSearch()
  const [searchValue,setSearchValue] = useState('')
  const currentpath = window.location.pathname
  

  return (
    <div className='navContainer'>
      <ul className='right'>
      <li><a href=''><img className='logo' src={logo}/></a></li>
        <li><Link to='/home'>Home</Link></li>
        <li><Link to='/shop'>Shop</Link></li>
        <li><a href='https://arifsultani291.digital/'>Portfolio</a></li>
        <li><a href=''>Contact</a></li>
      </ul>
      <ul className='left'>
       <Link to='/cart'><i className="fa-solid fa-basket-shopping"  style={{marginRight:20}}></i></Link> 
        <Link to='/register'><i className="fa-regular fa-user"></i></Link>
      </ul>
    </div>
  )
}

export default Navbar
